<template>
  <div
    v-if="aliases.length"
    class="d-inline-flex align-center aliases-row"
    data-testid="email-aliases"
  >
    <div class="aliases-row__text">
      <v-tooltip v-if="showTooltip" open-delay="300" location="top">
        <template #activator="{ props: tooltipProps }">
          <span
            class="d-block caption text-indigo-medium ellipsis"
            v-bind="tooltipProps"
            data-testid="email-aliases-text"
          >
            {{ aliases[0] }}
          </span>
        </template>
        <span data-testid="email-aliases-tooltip">{{ aliases[0] }}</span>
      </v-tooltip>
      <span
        v-else
        class="d-block caption text-indigo-medium ellipsis"
        data-testid="email-aliases-text"
      >
        {{ aliases[0] }}
      </span>
    </div>
    <coro-popover
      class="ml-1 aliases-row__popover"
      :items="aliases"
      :title="$t('usersSettings.aliases')"
      :threshold="1"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from "vue";
import CoroPopover from "@/components/CoroPopover.vue";

export default defineComponent({
  components: {
    CoroPopover,
  },
  props: {
    aliases: {
      type: Array as PropType<string[]>,
      default() {
        return [];
      },
    },
    showTooltip: {
      type: Boolean,
      default: false,
    },
  },
});
</script>

<style lang="scss" scoped>
:deep(.coro-link) {
  color: rgb(var(--v-theme-indigo-medium)) !important;
  text-decoration: none;
}
</style>
